export enum SendFeedbackTypeEnum {
  Feedback = "Feedback",
  Error = "Error"
}

export type SendFeedbackReq = {
  type: SendFeedbackTypeEnum.Feedback
  text: string
  rating: number
}

export type SendErrorReq = {
  type: SendFeedbackTypeEnum.Error,
  text: string
  file?: null | File
}

export type SendFeedbackData = SendFeedbackReq | SendErrorReq
